import { loadTranslations } from '@ibk/shared-translation';
import { sharedUiTranslations } from '@ibk/shared-ui';
import { bpoTranslations } from '../pages/Bpo/translations';
import enUS from './en-US.json';
import esES from './es-ES.json';
import ptBR from './pt-BR.json';
export const dominioempresaTranslations = loadTranslations({
    'pt-BR': {
        ...sharedUiTranslations['pt-BR'],
        ...ptBR,
        ...bpoTranslations['pt-BR'],
    },
    'en-US': {
        ...sharedUiTranslations['en-US'],
        ...enUS,
        ...bpoTranslations['en-US'],
    },
    'es-ES': {
        ...sharedUiTranslations['es-ES'],
        ...esES,
        ...bpoTranslations['es-ES'],
    },
});
